import * as React from 'react';
import {
    AppBar,
    AppBarProps,
    LoadingIndicator,
    Logout,
    useDataProvider,
    useGetIdentity,
    UserMenu,
    useTranslate,
    useUserMenu
} from 'react-admin';
import KeyIcon from '@mui/icons-material/Key';
import PeopleIcon from '@mui/icons-material/People'; // 更合适的用户管理图标
import {
    ListItemIcon,
    ListItemText,
    MenuItem,
} from '@mui/material';
import { useEffect, useState } from 'react';

export const MyAppBar = (props: AppBarProps) => {
    const { identity } = useGetIdentity();

    return (
        <AppBar {...props} toolbar={
            <>
                <LoadingIndicator />
            </>
        } userMenu={<MyUserMenu />}>
        </AppBar>
    );
};

const MyUserMenu = () => {
    const dataProvider = useDataProvider();
    const [showUserManagement, setShowUserManagement] = useState(false);
    const [loading, setLoading] = useState(true);

    // 获取用户信息并检查角色
    useEffect(() => {
        const fetchUserInfo = async () => {
            try {
                const role = localStorage.getItem("permissions");
                // 检查 roleCode 是否是管理员（假设管理员角色码为 'admin'）
                setShowUserManagement(role === 'admin');
            } catch (error) {
                console.error('获取用户信息失败:', error);
                setShowUserManagement(false);
            } finally {
                setLoading(false);
            }
        };

        fetchUserInfo();
    }, [dataProvider]);

    if (loading) {
        return <UserMenu />; // 加载时显示空菜单
    }

    return (
        <UserMenu>
            <ChangePasswordMenuItem />
            {showUserManagement && <UserManagementMenuItem />}
            <Logout />
        </UserMenu>
    );
};

// 修改密码菜单项
const ChangePasswordMenuItem = React.forwardRef<HTMLLIElement>((props, ref) => {
    const { onClose } = useUserMenu();

    return (
        <MenuItem
            ref={ref}
            onClick={() => {
                onClose();
                window.location.href = '#/change-password';
            }}
            {...props}
        >
            <ListItemIcon>
                <KeyIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>修改密码</ListItemText>
        </MenuItem>
    );
});

// 新增用户管理菜单项（使用People图标）
const UserManagementMenuItem = React.forwardRef<HTMLLIElement>((props, ref) => {
    const { onClose } = useUserMenu();

    return (
        <MenuItem
            ref={ref}
            onClick={() => {
                onClose();
                window.location.href = '#/userManage';
            }}
            {...props}
        >
            <ListItemIcon>
                <PeopleIcon fontSize="small" /> {/* 更换为人员图标 */}
            </ListItemIcon>
            <ListItemText>用户管理</ListItemText>
        </MenuItem>
    );
});